import { nodeInstance } from "@/plugins/axios";
import { db } from "@/plugins/firebase";
const networkingDb = db.collection("networking");

const networkingUsersService = {};

networkingUsersService.createdNetworkingUsers = networkingUsers => {
  return nodeInstance.post(`/api/networking/user`, networkingUsers);
};

networkingUsersService.updatedNetworkingUsers = networkingUsers => {
  return nodeInstance.patch(`/api/networking/user`, networkingUsers);
};

networkingUsersService.userNetworkingParticipant = networkingUsers => {
  return nodeInstance.post(`/api/networking/user/participant`, networkingUsers);
};
networkingUsersService.deleteNetworkingUsers = idNetworking => {
  const params = {
    id: idNetworking
  };
  return nodeInstance.delete(`/api/networking/`, { params });
};

// Sin limit: con limit(aforo), cuando los inscritos superan el aforo cada
// alta nueva desplaza a otro documento fuera de la consulta, y Meet.vue lo
// recibe como "removed" y saca a toda la sala. El aforo lo controla gestor-api
// al emitir el token.
networkingUsersService.getNetworkingUsers = (networkingId) => {
  return networkingDb.where("networkingId", "==", networkingId);
};

export default networkingUsersService;
